
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M3.005 17.065a1.407 1.407 0 01-1.24-2.073L8.253 2.908a1.407 1.407 0 012.48 0l6.488 12.084a1.407 1.407 0 01-1.24 2.073H3.005z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.493 6.932v4.433-4.433z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.493 6.932v4.433","stroke":"#fff","stroke-width":"1.759","stroke-linecap":"square"}}),_c('path',{attrs:{"d":"M9.852 14.13a.352.352 0 11-.704 0 .352.352 0 01.704 0z","fill":"#fff","stroke":"#fff","stroke-width":"1.407"}})])
          )
        }
      }
    